module.exports = __webpack_public_path__ + "img/LOGO-PNG-15.57d55988.png";